import { useCallback, useMemo } from "react";

import { Button } from "@/components/ui/button/button";
import ArrowRightIcon from "@/components/ui/icon/arrow-right";

type Props = {
	type: "next" | "prev";
	onActionCallback: () => void;
};

export const CalendarAction = ({ type, onActionCallback }: Props) => {
	/**
	 * 押下時の処理
	 */
	const handleClick = useCallback(() => {
		onActionCallback();
	}, [onActionCallback]);

	const RenderIcon = useMemo(
		() =>
			type === "next" ? (
				<ArrowRightIcon className="fill-zinc-800" />
			) : (
				<ArrowRightIcon className="-scale-x-100 scale-y-100 fill-zinc-800" />
			),
		[type],
	);

	return (
		<Button type="button" variant="no-outline" size="icon" onClick={handleClick}>
			{RenderIcon}
		</Button>
	);
};
